import type { RadioTabSize, RadioTabsProps } from './const';
import type { RadioTabProps } from './RadioTab';
import type { RadioTabsRef } from './RadioTabs';
import RadioTab from './RadioTab';
import RadioTabs from './RadioTabs';

export { RadioTab, RadioTabs };
export type { RadioTabProps, RadioTabSize, RadioTabsProps, RadioTabsRef };

export default RadioTabs;
